import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CUSTOM_EVENT_NAME } from '@typesApp/AppEvent'
import { useAppDrawer } from '@hooks/useAppDrawer'
import { useAppErrorHandler } from '@hooks/useAppErrorHandler'
import { useAppDrawerEventListener } from '@hooks/useAppDrawerEventListener'
import {
  enableUnsavedChangesModalSelector,
  hasUnsavedChangesSelector,
  showUnsavedChangesModal,
} from '@redux/slices/workflowSlice'
import { Drawer } from '@components/ui-css/Drawer'
import { AppRoutes } from './components/AppRoutes'
import { DrawerTopHeader } from './components/DrawerTopHeader'

export const AppContainer: React.FC = () => {
  const dispatch = useDispatch()
  const hasUnsavedChanges = useSelector(hasUnsavedChangesSelector)
  const enablePrompt = useSelector(enableUnsavedChangesModalSelector)
  const { isVisible, showHeader, activeStep, onClose, hideNavigateBack, hideCloseButton, onNavigateBack } =
    useAppDrawer()
  const eventListener = useAppDrawerEventListener()

  useAppErrorHandler()

  /**
   * Handle drawer events
   */
  useEffect(() => {
    document.addEventListener(CUSTOM_EVENT_NAME.DRAWER, eventListener)
    return () => {
      document.removeEventListener(CUSTOM_EVENT_NAME.DRAWER, eventListener)
    }
  }, [eventListener])

  const handleClose = () => {
    if (!hasUnsavedChanges || !enablePrompt) {
      onClose()
    } else {
      dispatch(showUnsavedChangesModal())
    }
  }

  const handleNavigateBack = () => {
    onNavigateBack?.()
  }

  return (
    <Drawer
      open={isVisible}
      hideCloseButton={!showHeader || hideCloseButton}
      onClose={handleClose}
      topHeader={
        showHeader ? (
          <DrawerTopHeader
            activeStep={activeStep}
            hideNavigateBack={hideNavigateBack}
            onNavigateBack={handleNavigateBack}
          />
        ) : undefined
      }
    >
      <AppRoutes />
    </Drawer>
  )
}
